var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[('COMPLETED' !== _vm.item.state)?_c('span',[_vm._v(_vm._s(_vm.getCurrentStep(_vm.item[_vm.headerId]))+"/"+_vm._s(_vm.getTotalSteps() + 1))]):_c('span',[_vm._v(_vm._s(_vm.getTotalSteps() + 1)+"/"+_vm._s(_vm.getTotalSteps() + 1))])])
}
var staticRenderFns = []

export { render, staticRenderFns }